import React, { useEffect, useMemo, useRef } from "react";
import useFilterLabels from "../../../../hooks/useFilterLabels";
import { ModelFilterLabel } from "../../../../utils/labels";
import FilterPillButton from "../../common/FilterPillButton";
import * as Styles from "./styles/ActiveFilterSliderStyles";
import { ModelFilterId } from "../../../../utils/constants/filterConstants";
import type { PosType } from "../../../../../../../common-deprecated/types/CommonTypes";

type ActiveFilterSliderPillType = {
    filterId: ModelFilterId;
    showFilter?: (pos: PosType) => void;
    update?: () => void;
    activeFilter?: ModelFilterId | null;
    isSidebar?: boolean;
};

const ActiveFilterSliderPill = ({
    filterId,
    showFilter,
    update,
    activeFilter,
    isSidebar,
}: ActiveFilterSliderPillType): JSX.Element => {
    const { midLabel, removeFilter, isActive } = useFilterLabels(filterId);
    const filterContainerRef = useRef<HTMLDivElement>(null);
    // This is a shortcut to support rerendering the parent container when the size of this component changes.
    // This is required because of the way the slider is implemented, and it seems like this is the easiest way to do it.
    useEffect(() => update && update(), [midLabel, update]);
    return useMemo(
        () => (
            <Styles.PillWrapper ref={filterContainerRef}>
                <FilterPillButton
                    isSelected={activeFilter === filterId}
                    closeFn={isActive ? removeFilter : undefined}
                    onClick={(pos) => {
                        if (showFilter) showFilter(pos);
                        if (isSidebar) removeFilter();
                    }}
                    ariaControlsId={filterId}
                >
                    {isActive ? (
                        <>
                            {midLabel.map(({ text, strikethrough }, index) => {
                                let parsedText = text.replace(/\s/g, "&nbsp;");
                                // Midlabel = 3 => 2 filters selected. This will result in the 2 labels being split by "and"
                                // When this is the case we want the first and second word to have a space.
                                if (midLabel.length === 3 && index !== 2) parsedText += "&nbsp;";
                                return (
                                    <Styles.PillText
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={`${text}${index}`}
                                        strikethrough={strikethrough}
                                        dangerouslySetInnerHTML={{ __html: parsedText }}
                                    />
                                );
                            })}
                        </>
                    ) : (
                        <>
                            {ModelFilterId.CarType === filterId && <ModelFilterLabel label="typePlus" />}
                            {ModelFilterId.Price === filterId && <ModelFilterLabel label="pricePlus" />}
                        </>
                    )}
                </FilterPillButton>
            </Styles.PillWrapper>
        ),
        [midLabel, removeFilter],
    );
};

export default ActiveFilterSliderPill;
